import React from 'react'

import { IconProps } from '../Types'

export const EyeOffOutline = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="EyeOffOutline"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" d="M21.38 10.47c-.35-.37-.82-.84-1.38-1.32-.4-.34-1.02-.31-1.38.08-.36.39-.33.98.07 1.33.5.43.92.85 1.23 1.19.07.08.11.17.11.27s-.03.19-.1.27c-.7.72-1.83 1.78-3.23 2.65-1.41.87-3.02 1.52-4.72 1.52h-.56c-.54 0-.98.42-.98.94s.43.94.98.94h.56c2.19 0 4.18-.83 5.77-1.82 1.59-.98 2.85-2.17 3.62-2.96h0c.39-.43.61-.98.61-1.54s-.22-1.11-.61-1.53v-.02ZM10.73 14.56l9.61-9.28c.38-.37.38-.97 0-1.34-.38-.37-1-.37-1.38 0l-2.8 2.71c-1.29-.6-2.7-.94-4.13-.97h-.02c-2.19 0-4.18.83-5.77 1.82-1.59.98-2.85 2.17-3.62 2.96h0c-.39.43-.61.98-.61 1.54s.22 1.11.61 1.53c1.03 1.09 2.2 2.04 3.47 2.85l-2.42 2.34c-.38.37-.38.97 0 1.34.38.37 1 .37 1.38 0l5.69-5.5h0Zm-.53-2.56c0-.46.19-.91.52-1.24.34-.33.8-.51 1.28-.51.13 0 .26.02.38.04l-2.14 2.07c-.03-.12-.04-.24-.05-.37h0Zm-6.13.27c-.07-.08-.11-.17-.11-.27s.03-.19.1-.27c.7-.72 1.83-1.78 3.23-2.65 1.41-.87 3.02-1.51 4.7-1.52.93.02 1.82.2 2.68.51l-.82.79c-.56-.31-1.19-.5-1.86-.5-1 0-1.95.38-2.66 1.06-.71.68-1.1 1.61-1.1 2.56 0 .64.19 1.25.52 1.8l-1.26 1.22c-1.27-.77-2.43-1.68-3.44-2.75v.02Z"/><path fill-rule="evenodd" d="m13.57,12.87c-.16.27-.39.49-.67.64-.47.26-.63.83-.37,1.29.27.45.86.61,1.33.35.57-.32,1.06-.77,1.39-1.33.28-.45.12-1.03-.35-1.29-.47-.26-1.07-.11-1.33.34h0Z"/>',
    }}
  />
)

EyeOffOutline.displayName = 'EyeOffOutline'

export const tags = ['EyeOffOutline', '']
